import { Link, LinkComponentProps } from '@tanstack/react-router';
import { ArrowUpRight } from 'lucide-react';
import { cn } from '@/lib/utils.ts';
import TruncatedCell from '@/components/table/components/TruncatedCell.tsx';
import { FieldImportance } from '@/components/table/types/FieldImportance.ts';

/**
 * `LinkComponentProps`, a nie `CreateLinkProps` — ten drugi ma `to: string`
 * i puszcza dowolny sklejony adres (patrz `CacLink`).
 */
type CellLinkProps = LinkComponentProps<'a'> & {
  /** Tylko pole PRIMARY jest wytłuszczone — reszta linków ma wagę komórki. */
  importance?: FieldImportance;
  children?: React.ReactNode;
  className?: string;
};

/**
 * Odnośnik w komórce tabeli — ciemny jak reszta wiersza, nie niebieski.
 *
 * Kolumna nazwisk nie ma wyglądać jak lista odnośników; że klik prowadzi gdzie
 * indziej niż klik w wiersz, mówi dopiero strzałka, która ciemnieje razem
 * z podkreśleniem nazwy.
 */
export const CellLink = ({
  className,
  children,
  importance,
  ...props
}: CellLinkProps) => (
  <Link
    className={cn(
      'group/celllink inline-flex max-w-full items-center gap-1 align-middle text-base-text transition',
      importance === FieldImportance.PRIMARY ? 'font-bold' : 'font-semibold',
      className,
    )}
    {...props}
  >
    {/* Własny dymek, bo nazwa ucina się wewnątrz linku: `TruncatedCell`
        opakowujący całą komórkę nie widzi wtedy przepełnienia i nie ma jak
        pokazać pełnego nazwiska. */}
    <TruncatedCell className="group-hover/celllink:underline">
      {children}
    </TruncatedCell>
    <ArrowUpRight
      className="size-3 shrink-0 text-neutral-300 transition group-hover/celllink:text-neutral-500"
      aria-hidden
    />
  </Link>
);
